import React, { useState, useEffect } from "react"
import { v4 as uuidv4 } from 'uuid';

function LandingSignpostsCta({ landingSignpostsCtaTitle, landingSignpostsCtaSubtitle, landingSignpostsCtaItems }){
    return (
        <section className="landing-signposts-cta">
            <div className="content-block">
                {landingSignpostsCtaTitle &&
                    <h3 className="landing-signposts-cta__title lp-heading-lg ">
                        {landingSignpostsCtaTitle}
                        {landingSignpostsCtaSubtitle &&
                            <span className="landing-signposts-cta__subtitle">
                                {landingSignpostsCtaSubtitle}
                            </span>
                        }
                    </h3>
                }

                {landingSignpostsCtaItems && Boolean(landingSignpostsCtaItems.length > 0) &&
                    <div className="lp-grid">
                        {landingSignpostsCtaItems.map((group, index) => { 
                              
                            let link = group.landingSignpostsCtaItemsItemTitleLink;  
                            let text = group.landingSignpostsCtaItemsItemText;   
                            let phone = group.landingSignpostsCtaItemsItemPhoneNumber; 
                            let email = group.landingSignpostsCtaItemsItemEmail;

                            return (
                                <div key={uuidv4()} className="landing-signposts__signpost">
                                    <div className="landing-signposts-link__wrapper">
                                        <a className="landing-signposts__link" href={link.url}>
                                            {link.title}
                                            <svg className="landing-signposts__arrow" xmlns="http://www.w3.org/2000/svg" width="13" height="23" viewBox="0 0 13 23" fill="none">
                                                <path d="M1.33472 21.5234L11.5877 11.2704L1.33472 1.01744" stroke="#041E41" strokeWidth="2"/>
                                            </svg>
                                        </a>
                                    </div>
                                    <div className="landing-signposts-text__wrapper">
                                        {text &&
                                            <div className="landing-signposts__text lp-body-lg" dangerouslySetInnerHTML={{__html: text}} />
                                        }
                                        <div>
                                            {phone &&
                                                <a href={"tel:" + phone} className="landing-signposts__number lp-body-lg">
                                                    {phone}
                                                </a>
                                            }
                                            {email &&
                                                <a href={"mailto:" + email} className="landing-signposts__email lp-body-lg">
                                                    {email}
                                                </a>
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                }

            </div>
        </section>
    )
}


export default LandingSignpostsCta
